<app-stepper-form
  header="Notification of Share Buy-Back Details"
  subheader="Form 280"
  [showSteps]="false"
  [steps]="steps"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [isLoading]="isLoading"
  [form]="stepperForm"
>
  <div class="step-content" [formGroup]="stepperForm">
    <app-stepper-form-description
      formKey="280"
      [hidden]="currentStep !== StepsEnum.FormDescription"
    ></app-stepper-form-description>

    <section
      class="step-section"
      [formGroupName]="StepsEnum.TheChange"
      [hidden]="currentStep !== StepsEnum.TheChange"
    >
      <h1 class="h1-heading">{{ steps[currentStepIndex].label }}</h1>

      <div class="form-group">
        <app-date-picker
          label="Date of Change"
          formControlName="changeDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [customErrors]="customDatepickerErrors"
        ></app-date-picker>
      </div>

      <div class="form-group">
        <app-select
          label="Type of share buy-back"
          formControlName="buyBackType"
          [options]="buyBackTypeOptions"
          [valuePrimitive]="true"
        ></app-select>
      </div>

      <div class="form-group">
        <app-select
          label="Documents attached to this form"
          formControlName="attachedDocumentType"
          [options]="buyBackDocumentTypeOptions"
          [valuePrimitive]="true"
        ></app-select>
      </div>
    </section>
  </div>
</app-stepper-form>
